import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const CreateProductAlertPage = lazy(() =>
  import("@scenes/ProductAlerts/components/CreateProductAlertPage").then((module) => ({
    default: module.CreateProductAlertPage,
  }))
);

export const productAlertsCreateNRO: NavigationRoutingObject = {
  Component: CreateProductAlertPage,
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
  section: "messaging",
  heading: (t: I18nT<"dashboard-navigation">) => t("product-alerts-create-nro-heading", "Product Alerts"),
  pageNameForTracking: () => "Create Product Alert",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    return featureOn("product_alerts") && hasPermission("appGroup", { permission: "viewCanvases" });
  },
  showInSearchResults: false,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/product_alerts/:appGroupId",
};
